// extracted by mini-css-extract-plugin
export var auto = "_2h-1";
export var spinner = "_2h-0";